import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './NewFinanceUploadFile.css';

const NEW_FINANCE_ROOT =
  process.env.REACT_APP_NEW_FINANCE_BASE || '/new-finance';

function NewFinanceUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={NEW_FINANCE_ROOT}
      sessionPrefix="new_finance_file"
    />
  );
}

NewFinanceUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default NewFinanceUploadFile;
